export default [
  {
    key: "increasement",
    sortable: true,
    sortField: "createdAt",
    label: "label.no",
    thClass: "w-50px",
  },
  {
    key: "name",
    sortable: true,
    sortField: "name",
    label: "field.departmentName",
    stickyColumn: true,
    variant: "light",
  },
  {
    key: "workSchedule",
    label: "breadcrumb.workingSchedule",
  },
  {
    key: "isActive",
    label: "field.status",
  },
  // {
  //   key: "totalEmployee",
  //   label: "field.totalEmployee",
  // },
  // {
  //   key: "totalManager",
  //   label: "field.totalManager",
  // },
  {
    key: "createdAt",
    sortable: true,
    sortField: "createdAt",
    label: "field.createDate",
  },
  {
    key: "actions",
    label: "general.action",
  },
];
